import React from "react";

import { useTranslation } from "react-i18next";
import { TableHead as MUITableHead, TableRow } from "@mui/material";

import { SortableTableHeader, UnsortableTableHeader } from "@/components/molecules";

import { TableHeadProps } from "./types";

const TableHead = <ObjectType, SortPropertyType extends string>({
    columns,
    handleSort,
    orderBy,
}: TableHeadProps<ObjectType, SortPropertyType>): React.ReactElement => {
    const { t } = useTranslation();

    return (
        <MUITableHead>
            <TableRow>
                {columns.map((column) =>
                    column.notSortable ? (
                        <UnsortableTableHeader
                            key={column.unsortableKey ? column.unsortableKey : "notSortable"}
                            labelKey={column.unsortableKey}
                        >
                            {t(column.label)}
                        </UnsortableTableHeader>
                    ) : (
                        <SortableTableHeader<SortPropertyType>
                            key={`sortable-${column.sortableKey}`}
                            labelKey={column.sortableKey}
                            onSort={handleSort}
                            orderBy={orderBy}
                        >
                            {t(column.label)}
                        </SortableTableHeader>
                    ),
                )}
            </TableRow>
        </MUITableHead>
    );
};

export default TableHead;
